import React, { FC } from 'react';
import style from './linearToggleDivider/ToggleExpander.module.scss';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { Icon, IconButton } from '@kontentino/ui';
import clsx from 'clsx';
type Props = {
  onClick(): void;
  isExpanded: boolean;
  className?: string;
};

const LinearToggleDivider: FC<Props> = (props) => {
  return (
    <div className={clsx(style.linearToggleDivider, props.className)}>
      <IconButton
        variant="secondary"
        onClick={props.onClick}
        data-name={`insights_posts-performance_statistics_show-${
          props.isExpanded ? 'less' : 'more'
        }`}
        icon={<Icon icon={props.isExpanded ? faChevronUp : faChevronDown} />}
      />
    </div>
  );
};

export default LinearToggleDivider;
